import React from 'react';
import { Image, StatusBar, StyleSheet, Text, View } from './base_components';
import ImageButton from './buttons/image_button';
import ModalContent from './modal_content';
import WalletOvelay from './overlays/wallet_overlay';

import util from '../tools/util';
import WalletStore from '../stores/wallet_store';

const styles = StyleSheet.create({
  homeTop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    paddingTop: util.safeTop(),
    backgroundColor: 'white',
    flexDirection: 'column',
    borderBottomColor: '#ccc',
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  barInner: {
    alignSelf: 'stretch',
    height: '4rem',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  center: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  left: {
    marginLeft: '1rem',
    width: '3.5rem',
    height: '3.5rem',
    borderRadius: '0.4rem',
  },
  right: {
    marginRight: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    margin: '0.3rem',
    flex: 1,
    alignSelf: 'stretch',
  },
  text: {
    color: '#333',
    fontSize: '1.6rem',
    fontWeight: 'bold',
  },
  spacer: {
    flex: 1,
  },
  connectButton: {
    padding: '0.75rem',
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '0.5rem',
    backgroundColor: '#0a60fe',
  },
});

const LINK_IMG = require('../assets/img/link_white.png');
const HARBOUR_ICON = require('../assets/img/harbour_color.png');

type Props = {
  style?: any;
};
type State = {
  has_wallet: boolean;
};
export default class HomeTop extends React.PureComponent<Props> {
  state = {
    has_wallet: WalletStore.hasWallet(),
  };
  componentDidMount() {
    WalletStore.addChangeListener(this._onWalletUpdate);
    this._onWalletUpdate();
  }
  componentWillUnmount() {
    WalletStore.removeChangeListener(this._onWalletUpdate);
  }
  _onWalletUpdate = () => {
    const has_wallet = WalletStore.hasWallet();
    this.setState({ has_wallet });
  };
  _onWalletPress = () => {
    const overlay = <WalletOvelay onDone={this._onConnectDone} />;
    ModalContent.showOverlay(overlay);
  };
  _onConnectDone = () => {
    ModalContent.hideOverlay();
  };
  render() {
    const { style } = this.props;
    const { has_wallet } = this.state;

    let button = null;
    if (has_wallet) {
      button = (
        <ImageButton
          style={styles.connectButton}
          source={LINK_IMG}
          onPress={this._onWalletPress}
        />
      );
    }
    return (
      <View style={[styles.homeTop, style]}>
        <StatusBar barStyle='dark-content' />
        <View style={styles.barInner}>
          <View style={styles.center}>
            <Text style={styles.text}>Harbour Swap</Text>
          </View>
          <View style={styles.left}>
            <Image
              style={styles.icon}
              resizeMode='contain'
              source={HARBOUR_ICON}
            />
          </View>
          <View style={styles.spacer} />
          <View style={styles.right}>{button}</View>
        </View>
      </View>
    );
  }
}
